import { cacheDom } from '../utils/QuerySelectors.js'
import { getProductsBySkus } from '../utils/Product.js'
import { addLineItems } from '../utils/Cart.js'
import { customerUpdateByAdmin, updateMarketingConsent, searchOrder, formatOrder } from '../utils/Customer.js'

const dom = {}
const qs = {
  orderSection: 'data-section-type="main-order"',
  accountSection: 'data-section-type="main-account"',
  orderReturn: 'data-order-return',
  wishlist: 'data-account-wishlist',
  continueShopping: 'data-account-continue-shopping',
  wishlistNav: 'data-account-wishlist-nav-buttons',
  accountCountry: 'data-account-country',
  accountNewsletter: 'data-account-newsletter',
  addressAdd: 'data-address-add',
  newAddressData: 'data-new-address-data',
  navMobileSelected: 'data-mobile-selected',
  navMobileSelectedTitle: 'data-mobile-selected-title',
  preferenceSave: 'data-email-preferences-save',
}

const qsAll = {
  returnables: 'data-returnable',
  returnableESWs: 'data-returnable-esw',
  reasonSelectors: 'data-return-reason',
  removeFromWishlist: 'data-wishlist-remove',
  addToCartFromWishlist: 'data-wishlist-atc',
  accountNavItems: 'data-account-item',
  shoppingPreferences: 'data-account-preferences',
  editAddressBtns: 'data-address-edit',
  removeAddressBtns: 'data-confirm-message',
  wishlistCounts: 'data-account-wishlist-count',
}

const state = {
  emailPreferencesUpdated: false,
  shoppingPreferences: null,
  accountCountry: null,
  accountNewsletter: null,
  gqlResults: null,
}


const onError = (error) => {
  console.error('Error while performing Swym operation', error)
}

/**
 * Update wishlist Item Size
 */
const updateWishlistItemSize = async (oldSku, newSku, itemElement, swymProducts) => {
  if (oldSku === newSku) return;

  try {
    // Get variant data
    const allVariantEdges = state.gqlResults.map(r => r.node.variants.edges).flat();
    const newVariantEdge = allVariantEdges.find(e => e.node.sku === newSku);

    if (!newVariantEdge) return;

    const newVariant = newVariantEdge.node;
    const productNode = state.gqlResults.find(r =>
      r.node.variants.edges.some(e => e.node.sku === newSku)
    ).node;

    const productId = productNode.id.replace('gid://shopify/Product/', '');
    const oldVariantId = swymProducts.find(p => p.sku === oldSku).epi;
    const newVariantId = newVariant.id.replace('gid://shopify/ProductVariant/', '');
    const listId = itemElement.dataset.swymLid;

    // Clean product objects - only required fields
    const productToRemove = {
      epi: oldVariantId,
      empi: productId,
      du: `${window.location.origin}/products/${productNode.handle}`
    };

    const productToAdd = {
      epi: newVariantId,
      empi: productId,
      du: `${window.location.origin}/products/${productNode.handle}`,
      qty: 1
    };

    // Remove old, then add new
    _swat.deleteFromList(listId, productToRemove,
      () => {
        _swat.addToList(listId, productToAdd,
          () => {
            console.log("Successfully updated variant");
            window.location.reload();
          },
          (error) => {
            console.error("Failed to add new variant:", error);
            window.location.reload();
          }
        );
      },
      (error) => {
        console.error("Failed to remove old variant:", error);
        window.location.reload();
      }
    );

  } catch (error) {
    console.error("Function error:", error);
    window.location.reload();
  }
};

const addSizeButtonListeners = (container, swymProducts) => {
    container.querySelector('[data-cancel-size-selection]').addEventListener('click', (e) => {
        e.preventDefault()
        container.classList.add('hidden')
        container.classList.remove('flex')
    })

    container.querySelectorAll('[data-select-new-sku]').forEach(sizeBtn => {
        sizeBtn.addEventListener('click', (e) => {
            e.preventDefault()
            const newSku = sizeBtn.dataset.selectNewSku
            const oldSku = sizeBtn.dataset.oldSku
            updateWishlistItemSize(oldSku, newSku, sizeBtn.closest('[data-wishlist-item]'), swymProducts)
        })
    })
}

const renderSizeButtons = (sizeOptions, container, currentSku, swymProducts) => {
    container.innerHTML = ''
    container.classList.remove('hidden')
    container.classList.add('flex')

    let buttonsHTML = ''

    sizeOptions.forEach(option => {
        const isActive = option.sku === currentSku
        const isDisabled = !option.available

        buttonsHTML += `
            <button
                data-select-new-sku="${option.sku}"
                data-old-sku="${currentSku}"
                ${isDisabled ? 'disabled' : ''}
                class="
                    size-button p-1 border text-xs
                    ${isActive ? 'bg-grey text-white border-black' : 'bg-white text-black border-gray-400'}
                    ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}
                "
            >
                ${option.size}
            </button>
        `
    })

    buttonsHTML += `
        <button
            data-cancel-size-selection
            class="underline text-xs p-1 mt-2"
        >
            ${window.accountStrings.wishlist.cancel}
        </button>
    `

    container.innerHTML = buttonsHTML
    addSizeButtonListeners(container, swymProducts)
}

const handleModifySize = (modifyBtn, swymProducts) => {
  const itemContainer = modifyBtn.closest('[data-wishlist-item]')
  const sizeContainer = itemContainer.querySelector('[data-size-selector-container]')
  const gqlResults = state.gqlResults

  if (!sizeContainer.classList.contains('hidden')) {
    sizeContainer.classList.add('hidden')
    sizeContainer.classList.remove('flex')
    return
  }

  const currentSku = modifyBtn.dataset.currentSku
  const productHandle = modifyBtn.dataset.productHandle

  const productData = gqlResults.find(r => r.node.handle === productHandle)
  if (!productData) return console.error('Product data not found for handle:', productHandle)

  const allVariants = productData.node.variants.edges

  const sizeOptionIndex = 1
  const sizeOptionName = productData.node.options.find((_, index) => index === sizeOptionIndex)?.name

  const currentVariant = allVariants.find(e => e.node.sku === currentSku)?.node
  const currentColor = currentVariant.selectedOptions.find(opt => opt.name !== sizeOptionName)?.value

  const sizeOptions = allVariants
      .filter(edge => {
        const colorMatch = edge.node.selectedOptions.find(opt => opt.name !== sizeOptionName)?.value === currentColor
        return colorMatch
      })
      .map(edge => {
          const sizeValue = edge.node.selectedOptions.find(opt => opt.name === sizeOptionName)?.value
          return {
            size: sizeValue,
            sku: edge.node.sku,
            available: edge.node.availableForSale,
          }
      })
      .filter((v, i, a) => a.findIndex(t => (t.size === v.size)) === i)
      .sort((a, b) => a.size.localeCompare(b.size, undefined, { numeric: true, sensitivity: 'base' }))

  renderSizeButtons(sizeOptions, sizeContainer, currentSku, swymProducts)
}

const getPreferences = () => {
  const shoppingPreferences = Array.from(document.querySelectorAll(`[${qsAll.shoppingPreferences}]:checked`))
    .map(preference => preference.value)
  const accountCountry = dom.accountCountry.value
  const accountNewsletter = dom.accountNewsletter.checked
  return {
    shoppingPreferences,
    accountCountry,
    accountNewsletter
  }
}
const setPreferencesState = () => {
  const { shoppingPreferences, accountCountry, accountNewsletter } = getPreferences()
  state.shoppingPreferences = shoppingPreferences
  state.accountCountry = accountCountry
  state.accountNewsletter = accountNewsletter
}
const preferenceUpdated = () => {
  const { shoppingPreferences, accountCountry, accountNewsletter } = getPreferences()
  return JSON.stringify(state.shoppingPreferences) != JSON.stringify(shoppingPreferences) ||
    state.accountCountry != accountCountry ||
    state.accountNewsletter != accountNewsletter
}
const updatePreferenceButton = () => {
  setTimeout(() => {
    const updated = preferenceUpdated()
    dom.preferenceSave.classList.toggle('button--primary', updated)
    dom.preferenceSave.disabled = !updated
  }, 300)
}

const updateActionsVisibility = (swatProducts) => {
  if(dom.continueShopping) {
    // Filter the list to include only items with a truthy SKU.
    const renderableProducts = swatProducts.filter(product => product.sku);

    if (renderableProducts.length > 0) {
      dom.continueShopping.classList.remove('flex')
      dom.continueShopping.classList.add('hidden')
    } else {
      dom.continueShopping.classList.add('flex')
      dom.continueShopping.classList.remove('hidden')
    }
  }
  if(dom.wishlistNav) {
    // Filter the list to include only items with a truthy SKU.
    const renderableProducts = swatProducts.filter(product => product.sku);

    if (renderableProducts.length > 0) {
      dom.wishlistNav.classList.remove('hidden')
    } else {
      dom.wishlistNav.classList.add('hidden')
    }
  }

}

const onSuccessWishlist = (removedProduct) => {
  console.log(`Successfully removed many Products from the List`, removedProduct)
  _swat.fetch((products) => {
    updateActionsVisibility(products)
    updateCounts(products)
  })
}

const updateCounts = (products) => {
  const skus = products.map((product) => product.sku).filter(Boolean)
  if (skus.length > 0) {
    getProductsBySkus((results) => {
      const count = products.filter(product => results.filter(r => r.node.variants.edges.filter((e) => e.node.sku == product.sku).length > 0).length > 0).length
      dom.wishlistCounts.forEach(wishlistCount => {
        wishlistCount.innerHTML = count
        if(wishlistCount.closest('.header-wishlist-count')) wishlistCount.closest('.header-wishlist-count').classList.toggle('!hidden', count == 0)
      })
    }, skus)
  } else {
    dom.wishlistCounts.forEach(wishlistCount => {
      wishlistCount.innerHTML = '0'
      if(wishlistCount.closest('.header-wishlist-count')) wishlistCount.closest('.header-wishlist-count').classList.add('!hidden')
    })
  }
}

/**
 * Update wishlist Item PDP
 */
const setupPdpWishlist = () => {
    const wishlistButton = document.querySelector('.pdp-custom-wishlist-button');
    if (!wishlistButton || typeof _swat === 'undefined') return;

    let isProcessing = false;

    wishlistButton.addEventListener('click', (e) => {
        e.preventDefault();

        if (isProcessing) return;

        const newVariantId = wishlistButton.getAttribute('data-variant-id');
        const productId = wishlistButton.getAttribute('data-product-id');
        const newSku = wishlistButton.getAttribute('data-sku') || null;

        isProcessing = true;
        wishlistButton.classList.add('button--loading');

        _swat.fetch(function(products) {

            const existingVariants = products.filter(p => p.empi == productId);
            let variantToKeep = existingVariants.find(p => p.epi == newVariantId || p.sku == newSku);
            let variantToRemove = existingVariants.find(p => p.epi != newVariantId);

            //  IF VARIANT ALREADY IN WISHLIST
            if (variantToKeep) {
              if (variantToRemove && variantToRemove.epi != variantToKeep.epi) {
                // Request to Swym
                _swat.removeFromWishList(variantToRemove,
                    // callback on success
                    () => {
                        finalizeWishlistAction(); // Update
                    },
                    // callback on failure
                    () => {
                        finalizeWishlistAction(); // Update anyway
                    }
                );
              } else {
                // Nothing to remove
                finalizeWishlistAction(); // Update
              }
              return;
            }

            // IF THE VARIANT IS NEW AND THERE'S AN OLD ONE TO REMOVE
            if (variantToRemove) {
                const listId = variantToRemove.listId || variantToRemove.lid;
                if (!listId) {
                   console.error("Swym Error: listId is missing from variantToRemove object. Cannot remove old variant.");
                   finalizeWishlistAction();
                   return;
                }
                variantToRemove.listId = listId;
                variantToRemove.lid = listId;

                // Remove old variant first
                _swat.removeFromWishList(variantToRemove,
                    function() {
                        // Then add the new variant
                        _swat.addToList(listId, {
                            epi: newVariantId,
                            empi: productId,
                            sku: newSku,
                            qty: 1
                        }, function() {
                            finalizeWishlistAction();
                        },
                        (error) => { console.error("Errore aggiunta Swym:", error); finalizeWishlistAction(); });
                    },
                    (error) => { console.error("Errore rimozione Swym:", error); finalizeWishlistAction(); }
                );
            } else {
                // IF NO EXISISTING VARIANT IS FOUND, THEN ADD THE NEW ONE AS USUAL
                _swat.addToList(null, {
                    epi: newVariantId,
                    empi: productId,
                    sku: newSku,
                    qty: 1
                }, function() {
                    finalizeWishlistAction();
                },
                (error) => { console.error("Errore aggiunta Swym:", error); finalizeWishlistAction(); });
            }

          function finalizeWishlistAction() {
            isProcessing = false;
            wishlistButton.classList.remove('button--loading');

            if (typeof _swat.refreshWishlistButton === 'function') {
                _swat.refreshWishlistButton();
            } else if (typeof _swat.updateWislistButton === 'function') {
                _swat.updateWislistButton(wishlistButton);
            } else {
                console.warn("Warning: Unable to find a _swat method to update the Wishlist button");
            }
          }

        }, (error) => {
             console.error("Error fetch Wishlist:", error);
             isProcessing = false;
             wishlistButton.classList.remove('button--loading');
        });
    });
};

/**
 * Update the product name in the popup
 * based on the clicked element's context (PDP/PLP).
 */
const updatePopUpProductInfo = (clickedElement) => {
  const popupSelectors = ['#wishlist-login-warning', '#wishlist-added-popup'];

  popupSelectors.forEach((popupSelector) => {
    updatePopUp(clickedElement, popupSelector);
  });
};

const updatePopUp = (clickedElement, popupSelector) => {
  const productNameSpan = document.querySelector(`${popupSelector} [data-show-product-name]`);
  if (!productNameSpan) return;

  let productName = 'The product'; // fallback

  // Guest
  const productNameContainer = document.querySelector(`${popupSelector} [data-product-save-message]`);
  if (clickedElement.hasAttribute('data-wishlist-guest-check') && productNameContainer) {
    productNameContainer.classList.add('hidden');
  } else if (productNameContainer) {
    productNameContainer.classList.remove('hidden');
  }

  // PDP
  const pdpNameElement = document.querySelector('[data-product-name-title]');
  if (pdpNameElement && pdpNameElement.closest('.product-page, [data-section-type="main-product"]')) {
    productName = pdpNameElement.textContent.trim();
  }

  // PLP
  else {
    const parentCard = clickedElement.closest('[data-product-card], .product-item, .grid-product');
    let cardTitle = parentCard ? parentCard.querySelector('[data-product-name-title]') : null;

    if (!cardTitle) {
      cardTitle = parentCard
        ? parentCard.querySelector('[data-product-title], .product-title, h2, h3')
        : null;
    }

    if (cardTitle) {
      productName = cardTitle.textContent.trim();
    }
  }
  productNameSpan.textContent = productName;
};


/**
 * Check cookies consent/Login
 */
const setupHeaderWishlistCheck = () => {
  const cookieWarning = document.getElementById('wishlist-cookie-warning');
  const loginWarning = document.getElementById('wishlist-login-warning');
  const addedProduct = document.getElementById('wishlist-added-popup');
  const loginOpener = document.querySelector('[data-wishlist-login-opener]');
  const closeManualBtn = loginWarning ? loginWarning.querySelector('[data-wishlist-close-warning]') : null;


  if (!cookieWarning && !loginWarning) {
    return {
      showCookieWarning: () => {},
      hideCookieWarning: () => {},
      showLoginWarning: () => {},
      showAddedProduct: () => {},
      hideAddedProduct: () => {},
      closeWarning: () => {}
    };
  }

  // Remove cookie warning
  const hideCookieWarning = () => {
    if (cookieWarning) cookieWarning.classList.add('hidden');
  };

  // Remove added product popup
  const hideAddedProduct = () => {
    if (addedProduct) addedProduct.classList.add('hidden');
  };

  // Show cookie warning
  const showCookieWarning = (e) => {
    if (e) e.preventDefault();
    if (cookieWarning) cookieWarning.classList.remove('hidden');

    if (loginWarning) loginWarning.classList.add('hidden');

    const cookieBanner = document.getElementById('CookieConsent');
    if (cookieBanner) {
      cookieBanner.scrollIntoView({ behavior: 'smooth' });
    }
    setTimeout(hideCookieWarning, 5000);
  }

  const closeWarning = () => {
    if (loginWarning) loginWarning.classList.add('hidden');
  };

  // Show login warning
  const showLoginWarning = (e) => {
    if (loginWarning) loginWarning.classList.remove('hidden');
    if (cookieWarning) cookieWarning.classList.add('hidden');
  }

  // Show added product popup
  const showAddedProduct = (e) => {
    if (addedProduct) addedProduct.classList.remove('hidden');
    if (cookieWarning) cookieWarning.classList.add('hidden');
    if (loginWarning) loginWarning.classList.add('hidden');
    setTimeout(hideAddedProduct, 5000);
  }

  if (closeManualBtn) {
    closeManualBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeWarning();
    });
  }

  // click link login opener (Logica per chiudere il pop-up)
  if (loginOpener && loginWarning) {
    loginOpener.addEventListener('click', closeWarning);
  }
  document.addEventListener('trackingConsentAccepted', hideCookieWarning);
  document.addEventListener('trackingConsentDeclined', hideCookieWarning);

  return {
    showCookieWarning: showCookieWarning,
    hideCookieWarning: hideCookieWarning,
    showLoginWarning: showLoginWarning,
    showAddedProduct: showAddedProduct,
    hideAddedProduct: hideAddedProduct,
    closeWarning: closeWarning
  };
};

/**
 * Button cookie listener
 */
const openOneTrust = () => {
  const oneTrustLink = document.getElementById('open-onetrust-preferences');

  if (!oneTrustLink) return;

  oneTrustLink.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof OneTrust !== 'undefined' && typeof OneTrust.ToggleInfoDisplay === 'function') {
        OneTrust.ToggleInfoDisplay();
        const warningMessage = document.getElementById('wishlist-cookie-warning');
        if (warningMessage) {
          warningMessage.classList.add('hidden');
        }
      }
  });
};

/**
 * Forces the Swym Wishlist button status to update
 * when a new variant (size) is selected on the PDP.
 */
const setupPdpWishlistRefresh = () => {
  const sizeSwatches = document.querySelectorAll('[data-size-swatch]');
  const wishlistButton = document.querySelector('.swym-button.pdp-custom-wishlist-button');

  if (!sizeSwatches.length || !wishlistButton) return;

  const resetWishlistButtonState = () => {
    wishlistButton.classList.remove('swym-added');
    wishlistButton.removeAttribute('data-swym-list-item');
  };

  sizeSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
          resetWishlistButtonState();

          const checkSwatReady = setInterval(() => {
              if (typeof _swat != 'undefined' && _swat && _swat.refreshWishlistButton) {
                clearInterval(checkSwatReady);
                _swat.refreshWishlistButton(wishlistButton);
              } else if (typeof _swat != 'undefined' && _swat && _swat.updateWislistButton) {
                clearInterval(checkSwatReady);
                _swat.updateWislistButton(wishlistButton);
              }
          }, 50);
          setTimeout(() => { clearInterval(checkSwatReady); }, 1000);
      });
  });
};

export const setupAccount = () => {
  cacheDom(dom, qs, qsAll);
  openOneTrust();
  setupPdpWishlistRefresh();
  const wishlistHandlers = setupHeaderWishlistCheck();
  const SESSION_KEY = 'wishlistGuestModalShown';
  const wishlistElements = document.querySelectorAll('[data-wishlist-cookie-check]');
  const isCustomerLoggedInString = window.customerLoggedIn;
  const isCustomerLoggedIn = (isCustomerLoggedInString === "true");


  // hide warning if logged in
  if (isCustomerLoggedIn) {
      wishlistHandlers.closeWarning();
  }

  function handleWishlistClick(e) {

    //session key for link header
    const modalShown = sessionStorage.getItem(SESSION_KEY);
    const isSwymButton = e.currentTarget.hasAttribute('data-swaction');
    const consent = Shopify.customerPrivacy.currentVisitorConsent();

    // check cookies & Login
    if (isCustomerLoggedIn && consent.preferences === 'no') {
      document.body.classList.add('no-consent');

      wishlistHandlers.showCookieWarning(e);
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    } else {
      document.body.classList.remove('no-consent');
      document.body.classList.add('consent-given');
    }

    // customer logged in + cookies accepted + click pdp/plp
    if (isSwymButton && isCustomerLoggedIn && consent.preferences === 'yes') {
      // Update product name
      updatePopUpProductInfo(e.currentTarget);
      wishlistHandlers.showAddedProduct(e);

      return;
    }

    // Check cookies
    if (!(consent && consent.preferences === 'yes')) {
      wishlistHandlers.showCookieWarning(e);
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    wishlistHandlers.hideCookieWarning();


    // Wishlist Button Logic (PDP/PLP) - Always save, ALWAYS show notification if Guest
    if (isSwymButton && !isCustomerLoggedIn) {
      // Update product name
      updatePopUpProductInfo(e.currentTarget);
      wishlistHandlers.showLoginWarning(e);

      return;
    }

    // Logic Link Header Wishlist ( Redirect) - Notification ONLY on the first click if Guest
    if (!isSwymButton && !isCustomerLoggedIn && !modalShown) {
      // Update product name
      updatePopUpProductInfo(e.currentTarget);
      e.preventDefault();
      e.stopImmediatePropagation();

      wishlistHandlers.showLoginWarning(e);
      sessionStorage.setItem(SESSION_KEY, 'true');
      return;
    }

    // Wishlist Link Header Management (User Logged In or Notice Already Displayed)
    if (!isSwymButton) {
      return;
    }
    // Subsequent clicks on the Wishlist Button (after the first notification/login)
    // User logged in or warning already displayed
    if (isSwymButton) {
      return;
    }
  }

  // Listener ({ capture: true })
  wishlistElements.forEach(element => {
    element.removeEventListener('click', handleWishlistClick, { capture: true });
    element.addEventListener('click', handleWishlistClick, { capture: true });
  });

  const historyPath = '/account#order_history'
  const preferencesPath = '/account#email_preferences'
  let selected = null
  dom.accountNavItems.forEach((navItem) => {
    if (location.href.includes(navItem.href)) selected = navItem
  })
  if (dom.navMobileSelectedTitle) dom.navMobileSelectedTitle.innerHTML = selected.innerHTML.trim()
  if(location.pathname.includes('/account')) {
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth",
      })
    }, 500)
    setTimeout(() => {
      window.scroll(0, 0)
    }, 1000)
  }
  if (location.hash == '#order_history') {
    let selected = null
    dom.accountNavItems.forEach((navItem) => {
      navItem.classList.toggle('underline', navItem.href.includes(historyPath))
      navItem.classList.toggle('hover:underline', !navItem.href.includes(historyPath))
      if (navItem.href.includes(historyPath)) selected = navItem
    })
    dom.navMobileSelectedTitle.innerHTML = selected.innerHTML.trim()
  }
  if (location.hash == '#email_preferences') {
    let selected = null
    dom.accountNavItems.forEach((navItem) => {
      navItem.classList.toggle('underline', navItem.href.includes(preferencesPath))
      navItem.classList.toggle('hover:underline', !navItem.href.includes(preferencesPath))
      if (navItem.href.includes(preferencesPath)) selected = navItem
    })
    dom.navMobileSelectedTitle.innerHTML = selected.innerHTML.trim()
  }
  dom.accountNavItems.forEach((navItem) => {
    navItem.addEventListener('click', () => {
      dom.accountNavItems.forEach((item) => {
        item.classList.toggle('underline', item == navItem)
        item.classList.toggle('hover:underline', item != navItem)
      })
      dom.navMobileSelectedTitle.innerHTML = navItem.innerHTML.trim()
    })
  })

  if (dom.navMobileSelected) {
    dom.navMobileSelected.addEventListener('click', (e) => {
      e.stopPropagation()
      dom.navMobileSelected.classList.toggle('account-mobile-nav-selected')
    })
    window.addEventListener('click', () => {
      dom.navMobileSelected.classList.remove('account-mobile-nav-selected')
    })
  }

  if (dom.orderSection) {
    searchOrder((data) => {
      if(data.order) {
        dom.returnables.forEach(returnable => {
          const itemId = returnable.getAttribute(qsAll.returnables)
          const returnableESW = document.querySelector(`[data-returnable-esw="${itemId}"]`)
          if(data.order?.shippingAddress?.countryCodeV2 != 'US') {
            returnable.classList.toggle('!hidden', true)
            returnableESW.classList.toggle('!hidden', false)
          } else {
            returnable.classList.toggle('!hidden', false)
            returnableESW.classList.toggle('!hidden', true)
          }
        })

        dom.reasonSelectors.forEach((reasonSelector) => {
          reasonSelector.addEventListener('change', () => {
            window.initOrderReturn(
              reasonSelector.getAttribute(`${qsAll.reasonSelectors}`),
              dom.orderReturn,
              reasonSelector.value,
              formatOrder(data.order),
            )
          })
        })
      }
    },
    {
      number: window.orderNumber
    })
  }

  // Enabling PDP Wishlist in background
  const checkSwatReadyForPDP = setInterval(() => {
    if (typeof _swat != 'undefined' && _swat && _swat.fetch) {
        clearInterval(checkSwatReadyForPDP);
        setupPdpWishlist();
    }
  }, 100);

  dom.wishlistCounts = document.querySelectorAll(`[${qsAll.wishlistCounts}]`)
  // INCREASED FETCH INTERVAL TO ALLOW SYNCHRONIZATION AFTER LOGIN
  const swatInterval = setInterval(() => {
    if (typeof _swat != 'undefined' && _swat && _swat.fetch) {
      clearInterval(swatInterval)
      setTimeout(() => {
        if (dom.wishlist || dom.wishlistCounts.length > 0) {
            _swat.fetch((products) => {
              updateActionsVisibility(products)
              updateCounts(products)

              const skus = products.map((product) => product.sku).filter(Boolean)
              if (skus.length > 0) {
                getProductsBySkus((results) => {
                  state.gqlResults = results

                  if (dom.wishlist) dom.wishlist.innerHTML = ''

                  products.forEach((product) => {
                    const result = results.filter(
                      (r) => r.node.variants.edges.filter((e) => e.node.sku == product.sku).length > 0,
                    )[0]
                    if (!!result && !!dom.wishlist) {
                      const node = result.node
                      const variant = node.variants.edges.filter((e) => e.node.sku == product.sku)[0]
                      const imageUrl = variant?.node?.image?.url || node.featuredImage.url
                      const varintId = variant?.node?.id.replace('gid://shopify/ProductVariant/', '')
                      const productId = node.id.replace('gid://shopify/Product/', '')

                      const listId = product.lid || product.listId;

                      dom.wishlist.innerHTML += `
                        <div class="account-wishlist-item text-xs relative flex flex-col justify-between" data-wishlist-item data-product-handle="${node?.handle}" data-swym-lid="${listId}">
                          <div class="relative">
                            <a href="/products/${node?.handle}?variant=${varintId}">
                              ${imageUrl ? '<img class="w-full h-auto block mb-5" src="' + imageUrl + '&width=200' + '" />' : ''}
                              <div class="mb-2.5">${node.title}</div>
                            </a>
                            <div class="mb-2.5">
                              ${(() => {
                                const compareAt = parseFloat(variant?.node?.compareAtPrice?.amount);
                                const price = parseFloat(variant?.node?.price?.amount);
                                return (compareAt && compareAt > price)
                                  ? `<del class="text-fourth-grey">${window.currencySymbol}${variant?.node?.compareAtPrice?.amount}</del>`
                                  : '';
                              })()}
                              ${window.currencySymbol}${variant?.node?.price?.amount}
                            </div>

                            <div class="flex flex-col gap-1">
                              <div>
                                ${window.productStrings.size}:&nbsp;${variant?.node?.selectedOptions[1]?.value}
                                ${(() => {
                                  const sizes = node.variants.edges
                                    .map(e => e.node.selectedOptions[1]?.value)
                                    .filter(Boolean);
                                  const uniqueSizes = [...new Set(sizes)];

                                  // If more than one unique size, show modify option
                                  return uniqueSizes.length > 1
                                    ? `
                                      <span
                                        data-wishlist-modify-size
                                        data-current-sku="${product.sku}"
                                        data-product-handle="${node.handle}"
                                        class="cursor-pointer underline normal-case">
                                        ${window.accountStrings.wishlist.modify}
                                      </span>
                                    `
                                    : '';
                                })()}
                              </div>
                              <div>${window.productStrings.color}:&nbsp;${variant?.node?.selectedOptions[0]?.value}</div>
                            </div>
                            </div>

                          <div data-size-selector-container class="mt-4 hidden flex-wrap gap-2">
                              </div>
                          ${
                            variant?.node?.availableForSale
                              ? `<button class="button button--secondary w-full mt-6.25 ${Shopify.country == 'JP' ? '!text-xs' : ''}" data-wishlist-atc="` +
                                varintId +
                                `">${window.productStrings.addToBag}</button>`
                              : `<button class="button button--secondary w-full mt-6.25 opacity-50 ${Shopify.country == 'JP' ? '!text-xs' : ''}" disabled>${window.productStrings.soldOut}</button>`
                          }
                          <button class="text-white cursor-pointer z-1 absolute right-4 top-1 w-2.5 h-2.5" data-wishlist-remove="${variant?.node?.sku}">
                            ${window.globalIcons['icon-close']}
                          </button>
                        </div>
                      `
                    }
                  })

                  // Listener change size buttons
                  const modifySizeBtns = document.querySelectorAll('[data-wishlist-modify-size]')
                  modifySizeBtns.forEach((modifyBtn) => {
                      modifyBtn.addEventListener('click', (e) => {
                          e.preventDefault()
                          handleModifySize(modifyBtn, products)
                      })
                  })

                  const atcBtns = document.querySelectorAll(`[${qsAll.addToCartFromWishlist}]`)
                  atcBtns.forEach((atcBtn) => {
                    atcBtn.addEventListener('click', () => {
                      atcBtn.disabled = true
                      addLineItems(
                        (cart) => {
                          atcBtn.innerHTML = window.productStrings.added
                          window.initMiniCart(cart, true)
                          window.openCart(true)
                        },
                        [
                          {
                            id: atcBtn.getAttribute(qsAll.addToCartFromWishlist),
                            quantity: 1,
                          },
                        ],
                        atcBtn,
                      )
                    })
                  })
                  const removeBtns = document.querySelectorAll(`[${qsAll.removeFromWishlist}]`)
                  removeBtns.forEach((removeBtn) => {
                    removeBtn.addEventListener('click', () => {
                      const sku = removeBtn.dataset.wishlistRemove
                      const swymProducts = products.filter((product) => product.sku == sku)
                      if (swymProducts.length > 0) {
                        _swat.removeFromWishList(swymProducts[0], onSuccessWishlist, onError)
                        removeBtn.closest('[data-wishlist-item]').remove()
                      }
                    })
                  })
                }, skus)
              }
            })
            let event = 'sw:addedtowishlist'
            let listener = function(e) {
              _swat.fetch((products) => {
                updateCounts(products)
              })
            }
            _swat.evtLayer.addEventListener(event, listener)
            event = 'sw:removedfromwishlist'
            _swat.evtLayer.addEventListener(event, listener)
        }
      }, 1000)
    }
  }, 500)

  //Start:  Email Preferences
  setPreferencesState()

  dom.shoppingPreferences.forEach((shoppingPreference) => {
    shoppingPreference.addEventListener('input', () => {
      updatePreferenceButton()
    })
  })
  if (dom.accountNewsletter) {
    dom.accountNewsletter.addEventListener('input', () => {
      updatePreferenceButton()
    })
  }
  if (dom.accountCountry) {
    dom.accountCountry.addEventListener('change', () => {
      updatePreferenceButton()
    })
  }
  if(dom.preferenceSave) {
    dom.preferenceSave.addEventListener('click', () => {
      const values = dom.shoppingPreferences.filter((p) => p.checked).map((p) => p.value)
      dom.preferenceSave.disabled = true
      dom.preferenceSave.classList.add('button--loading')
      customerUpdateByAdmin(
        (customer) => {
          console.log('update email preferences', customer)

          updateMarketingConsent(
            (customer) => {
              console.log('update email preferences', customer)
              window.customerInfo = customer
              setPreferencesState()
              dom.preferenceSave.classList.remove('button--loading', 'button--primary')
            },
            {
              customer: {
                customerId: window.customerInfo.id,
                emailMarketingConsent: dom.accountNewsletter.checked
                  ? {
                      consentUpdatedAt: new Date().toISOString(),
                      marketingOptInLevel: 'SINGLE_OPT_IN',
                      marketingState: 'SUBSCRIBED',
                    }
                  : {
                      marketingState: 'UNSUBSCRIBED',
                    },
              },
            },
          )
        },
        {
          customer: {
            id: window.customerInfo.id,
            metafields: [
              window.customerInfo.shoppingPreferences
                ? {
                    id: window.customerInfo.shoppingPreferences.id,
                    value: JSON.stringify(values),
                  }
                : {
                    namespace: 'custom',
                    key: 'shopping_preferences',
                    type: 'list.single_line_text_field',
                    value: JSON.stringify(values),
                  },
              window.customerInfo.country
                ? {
                    id: window.customerInfo.country.id,
                    value: dom.accountCountry.value,
                  }
                : {
                    namespace: 'custom',
                    key: 'country',
                    type: 'single_line_text_field',
                    value: dom.accountCountry.value,
                  },
            ],
          },
        },
      )
    })
  }
  //End:  Email Preferences

  // Start: Address page
  if (dom.addressAdd) {
    dom.addressAdd.addEventListener('click', (e) => {
      const newAddressData = JSON.parse(dom.newAddressData.innerHTML)
      newAddressData.country = 'United States'
      window.openAddressForm(newAddressData)
    })
  }
  dom.editAddressBtns.forEach((editAddress) => {
    editAddress.addEventListener('click', (e) => {
      window.openAddressForm(
        JSON.parse(e.target.closest('[data-address]').querySelector('[data-edit-address-data]').innerHTML),
      )
    })
  })
  dom.removeAddressBtns.forEach((removeAddressBtn) => {
    removeAddressBtn.addEventListener('click', (e) => {
      e.preventDefault()
      if (confirm(removeAddressBtn.dataset.confirmMessage)) {
        fetch(removeAddressBtn.dataset.target, {
          method: 'DELETE',
        })
          .then((response) => response.text())
          .then((response) => {
            location.reload()
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      }
    })
  })
  // End: Address page
}